import { Toolbar, ToolbarInline } from './toolbar';
var toolbar = {
    menuDistance: 12,
    tools: [],
    icons: {},
    tooltips: {},
    showNames: {},
    Component: Toolbar,
};
var toolbarInline = {
    menuDistance: 18,
    tipDirection: 'up',
    tipDistance: 18,
    tools: [],
    Component: ToolbarInline,
};
var moduleOption = {
    toolbar: toolbar,
    toolbarInline: toolbarInline,
};
export { moduleOption };
//# sourceMappingURL=utils.js.map